import { FC } from "react"
import cx from "classnames"
import { FaFileCsv } from "react-icons/fa"

type Props = {
  className?: string
} & React.HTMLAttributes<HTMLOrSVGElement>

const CsvIcon: FC<Props> = ({ className, ...rest }: Props) => {
  return (
    <FaFileCsv
      className={cx("w-5 h-5 transition-opacity", className)}
      {...rest}
    />
  )
}

export default CsvIcon
